import React from 'react';
import dayjs from 'dayjs';
import i18n from '../../utils/i18n';
import timeUtils from '../../utils/timeUtils';

export default function FormattedDate({time, type = 'short'}) {
  /*
   * time:
   * type: short(default)/long/full
   * land:en(default)
   */
  const getFormat = type => {
    switch (type) {
      case 'long':
        return timeUtils.longTimeFormat();
      case 'full':
        return timeUtils.fullTimeFormat();
      default:
        return timeUtils.shortTimeFormat();
    }
  };

  if (!time) {
    return <div />;
  }
  return <span>{dayjs(time).format(getFormat(type))}</span>;
}
